import { render } from "./DemosDrawer.vue?vue&type=template&id=d87889f0&ts=true"
import script from "./DemosDrawer.vue?vue&type=script&lang=ts"
export * from "./DemosDrawer.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\wamp64\\www\\sisdeu\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__